import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button } from "react-bootstrap";
import "./hm-theme.css";

const CreateCompanyDetails = ({ isOpen, onRequestClose }) => {
  const navigate = useNavigate();
  const url = "/api/createAccount";
  const [companyDetails, setCompanyDetails] = useState({
    username: "",
    role: "ROLE_EMPLOYER",
    companyname: "",
    companycode: "",
    contact: "",
    description: "",
    pan: "",
    gstin: "",
    tan: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    pincode: "",
    state: "",
    createddate: "",
    domainName: "",
    sendNotification: false,
    pilotOrganization: false,
    companyProfileImage: {
      image: null,
      imageMeta: "",
    }
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    try {
      const emailCheckResponse = await axios.get(`/api/accounts/getByEmail=${companyDetails.username}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (emailCheckResponse.data) {
        toast.error("Email already exists.");
        setLoading(false);
        return;
      }
    } catch (error) {
      handleError(error);
      setLoading(false);
      return;
    }

    axios.post(url, {
      username: companyDetails.username,
      role: "ROLE_EMPLOYER",
      organization: {
        username: companyDetails.username,
        companyname: companyDetails.companyname,
        companycode: companyDetails.companycode,
        contact: companyDetails.contact,
        description: companyDetails.description,
        pan: companyDetails.pan,
        gstin: companyDetails.gstin,
        tan: companyDetails.tan,
        addressLine1: companyDetails.addressLine1,
        addressLine2: companyDetails.addressLine2,
        city: companyDetails.city,
        pincode: companyDetails.pincode,
        state: companyDetails.state,
        createddate: companyDetails.createddate,
        domainName: companyDetails.domainName,
        sendNotification: companyDetails.sendNotification,
        pilotOrganization: companyDetails.pilotOrganization,
        companyProfileImage: companyDetails.companyProfileImage
      }
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(() => {
      setLoading(false);
      const regiteredusername = {
        username: companyDetails.username,
        orgcode: companyDetails.companycode,
      };
      localStorage.setItem("RegistrationData", JSON.stringify(regiteredusername));
      onRequestClose();
      toast.success("Company account created successfully and Password sent to their email");
    }).catch((error) => {
      setLoading(false);
      handleError(error);
    });
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  function rhandle(e) {
    const { id, value } = e.target;
    setCompanyDetails((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  }

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered size="lg">
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">business</i>
          Create Company Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="row g-3 mb-3">
            <div className="col-md-6">
              <label htmlFor="companyname" className="form-label small fw-semibold">Company Name <span className="text-danger">*</span></label>
              <input className="form-control" id="companyname" type="text" placeholder="Company Name" value={companyDetails.companyname} onChange={rhandle} required />
            </div>
            <div className="col-md-6">
              <label htmlFor="companycode" className="form-label small fw-semibold">Company Code <span className="text-danger">*</span></label>
              <input className="form-control" id="companycode" type="text" placeholder="e.g. COMP123" value={companyDetails.companycode} onChange={rhandle} required />
            </div>
          </div>

          <div className="row g-3 mb-3">
            <div className="col-md-6">
              <label htmlFor="username" className="form-label small fw-semibold">Email Address <span className="text-danger">*</span></label>
              <input className="form-control" id="username" type="email" placeholder="company@domain.com" value={companyDetails.username} onChange={rhandle} required />
            </div>
            <div className="col-md-6">
              <label htmlFor="contact" className="form-label small fw-semibold">Contact Number <span className="text-danger">*</span></label>
              <input className="form-control" id="contact" type="text" placeholder="+91 XXXXXXXXXX" value={companyDetails.contact} onChange={rhandle} required />
            </div>
          </div>

          <div className="row g-3 mb-3">
            <div className="col-md-4">
              <label htmlFor="pan" className="form-label small fw-semibold">PAN</label>
              <input className="form-control" id="pan" type="text" placeholder="PAN Number" value={companyDetails.pan} onChange={rhandle} />
            </div>
            <div className="col-md-4">
              <label htmlFor="gstin" className="form-label small fw-semibold">GSTIN <span className="text-danger">*</span></label>
              <input className="form-control" id="gstin" type="text" placeholder="GSTIN Number" value={companyDetails.gstin} onChange={rhandle} required />
            </div>
            <div className="col-md-4">
              <label htmlFor="tan" className="form-label small fw-semibold">TAN</label>
              <input className="form-control" id="tan" type="text" placeholder="TAN Number" value={companyDetails.tan} onChange={rhandle} />
            </div>
          </div>

          <div className="row g-3 mb-4">
            <div className="col-md-6">
              <label htmlFor="domainName" className="form-label small fw-semibold">Domain Name <span className="text-danger">*</span></label>
              <input className="form-control" id="domainName" type="text" placeholder="e.g. company.com" value={companyDetails.domainName} onChange={rhandle} required />
            </div>
          </div>

          <hr className="my-3 text-muted" />
          <h6 className="fw-bold mb-3" style={{ color: "#2f3a88" }}>Company Address</h6>

          <div className="row g-3 mb-3">
            <div className="col-md-6">
              <label htmlFor="addressLine1" className="form-label small fw-semibold">Address Line 1 <span className="text-danger">*</span></label>
              <input className="form-control" id="addressLine1" type="text" placeholder="Street Address" value={companyDetails.addressLine1} onChange={rhandle} required />
            </div>
            <div className="col-md-6">
              <label htmlFor="addressLine2" className="form-label small fw-semibold">Address Line 2</label>
              <input className="form-control" id="addressLine2" type="text" placeholder="Suite / Floor" value={companyDetails.addressLine2} onChange={rhandle} />
            </div>
          </div>

          <div className="row g-3 mb-4">
            <div className="col-md-4">
              <label htmlFor="city" className="form-label small fw-semibold">City <span className="text-danger">*</span></label>
              <input className="form-control" id="city" type="text" placeholder="City" value={companyDetails.city} onChange={rhandle} required />
            </div>
            <div className="col-md-4">
              <label htmlFor="pincode" className="form-label small fw-semibold">Pincode <span className="text-danger">*</span></label>
              <input className="form-control" id="pincode" type="text" placeholder="Pincode" value={companyDetails.pincode} onChange={rhandle} required />
            </div>
            <div className="col-md-4">
              <label htmlFor="state" className="form-label small fw-semibold">State <span className="text-danger">*</span></label>
              <input className="form-control" id="state" type="text" placeholder="State" value={companyDetails.state} onChange={rhandle} required />
            </div>
          </div>

          <div className="d-flex flex-wrap gap-4 mb-4">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="pilotOrganization"
                checked={companyDetails.pilotOrganization}
                onChange={(e) => setCompanyDetails((prev) => ({ ...prev, pilotOrganization: e.target.checked }))}
              />
              <label className="form-check-label small fw-semibold" htmlFor="pilotOrganization">
                Pilot Organization
              </label>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="sendNotification"
                checked={companyDetails.sendNotification}
                onChange={(e) => setCompanyDetails((prev) => ({ ...prev, sendNotification: e.target.checked }))}
              />
              <label className="form-check-label small fw-semibold" htmlFor="sendNotification">
                Send Notification Email
              </label>
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>business</i>
              Create Company
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateCompanyDetails;
